import templateEmpty from "./stripoTemplateEmpty";
import template01 from "./stripoTemplate01";
import template02 from "./stripoTemplate02";
import template03 from "./stripoTemplate03";

const stripoTemplates = [templateEmpty, template01, template02, template03];

export default stripoTemplates;
